var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4918 10.9998C21.4918 16.9098 16.7008 21.6998 10.7918 21.6998C4.8828 21.6998 0.0917969 16.9098 0.0917969 10.9998C0.0917969 5.0908 4.8828 0.299805 10.7918 0.299805C16.7008 0.299805 21.4918 5.0908 21.4918 10.9998Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30095 13.752H5.22918L5.9924 11.8027H9.13808L9.90129 13.752H10.8605L8.11702 6.53236H7.05471L4.30095 13.752ZM6.26055 10.9879L7.56008 7.51216L8.86992 10.9879H6.26055ZM11.6773 6.53236V13.752H14.3073C16.0194 13.752 16.927 12.9784 16.927 11.7614C16.927 10.6991 16.2566 10.2144 15.3387 10.039C16.1741 9.82243 16.6279 9.24487 16.6279 8.39914C16.6279 7.23369 15.7719 6.53236 14.2351 6.53236H11.6773ZM12.5746 7.34715H14.2764C15.2149 7.34715 15.7306 7.78032 15.7306 8.50228C15.7306 9.23455 15.2046 9.66773 14.2764 9.66773H12.5746V7.34715ZM12.5746 10.4722H14.3073C15.38 10.4722 16.0091 10.9157 16.0091 11.7305C16.0091 12.4731 15.4212 12.9372 14.3073 12.9372H12.5746V10.4722Z",
    fill: "#D3DEE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c01ebfe497f974d01b0e3c4b07bc704d.svg";
export { ForwardRef as ReactComponent };